<template>
  <div class="room-single">
    <div class="container">
      <div class="lobby" v-if="lobby">
        <div class="row no-gutters">
          <div class="col-12 col-md-3">
            <LobbyTeam
              color="blue"
              :currentUserRole="currentUserRole"
              :teamName="teamAName"
              :lobbyUsers="lobbyUsersA"
              @swapTeam="swapTeam"
              @swapReady="swapReady"
              @kickPlayer="kickPlayer"
            ></LobbyTeam>
          </div>
          <div class="col">
            <div class="chat-container">
              <div class="chat-header">
                <h4>
                  LOBBY TICKRATE 128 - {{lobby.players_per_team}}x{{lobby.players_per_team}}
                  <span
                    v-if="lobby.map"
                  >{{lobby.map}}</span>
                  <span v-else>O mapa será votado dentro do servidor</span>
                  <strong>Chat</strong>
                </h4>
              </div>
              <LobbyChat :chatMessages="chat_messages"></LobbyChat>

              <form class="form-chat" v-on:submit.prevent="sendMessage">
                <b-form-input
                  v-model="message"
                  type="text"
                  maxlength="50"
                  placeholder="digite aqui sua mensagem e aperte ENTER para enviar"
                ></b-form-input>

                <div class="progress-indicator">
                  <div class="bar" ref="chatProgressBar"></div>
                </div>
              </form>

              <a
                v-if="!currentUserReady"
                v-on:click.prevent="swapReady(currentUser.id)"
                href="#"
                class="ready-button"
              >
                <span>Está pronto? Clique aqui</span>
                READY
              </a>
              <div v-else style="margin: 20px">
                <a
                  v-if="!server"
                  v-on:click.prevent="swapReady(currentUser.id)"
                  href="#"
                  class="btn btn-sm btn-danger"
                >cancelar ready</a>
              </div>

              <div class="columns" v-if="currentUserRole == 'lobby-leader' && matchCheck()">
                <div class="column column-50 column-offset-25">
                  <select v-model="map" id="mapField">
                    <option>de_mirage</option>
                    <option>de_cache</option>
                    <option>de_train</option>
                    <option>de_inferno</option>
                    <option>de_cbble</option>
                    <option>de_nuke</option>
                    <option>de_overpass</option>
                  </select>
                  <button class="button-primary" v-on:click.prevent="startPug">Começar Pug</button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-3">
            <LobbyTeam
              color="green"
              :currentUserRole="currentUserRole"
              :teamName="teamBName"
              :lobbyUsers="lobbyUsersB"
              @swapTeam="swapTeam"
              @swapReady="swapReady"
              @kickPlayer="kickPlayer"
            ></LobbyTeam>
          </div>
        </div>
      </div>

      <!-- <pre><code v-html="lobbyUrl"></code> <button type="button" name="button" class="button is-small is-primary is-outlined" v-clipboard:copy="lobbyUrl">copiar link da lobby</button></pre> -->
      <div class="game-ready-modal" v-if="server">
        <div class="content">
          <h1>SEU JOGO ESTÁ LIBERADO</h1>
          <div class="box-container">
            <div class="server">
              <p class="number">2</p>
              <a :href="connect_link" class="btn btn-lg btn-success">Clique aqui e entre no servidor</a>
              <h4 style="margin-top: 30px;font-size: 16px;">ou copie e cole no console</h4>
              <input class="input" type="text" :value="lobbyUrl">
              <button
                type="button"
                name="button"
                class="btn btn-sm btn-primary is-outlined"
                v-clipboard:copy="lobbyUrl"
              >copiar IP</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import ActionCable from "actioncable";
import LobbyChat from "@/components/LobbyChat";
import LobbyTeam from "@/components/LobbyTeam";
export default {
  name: "RoomSingle",
  data() {
    return {
      lobby: {},
      message: "",
      cable: null,
      server: null,
      is_eac: null,
      map: "de_mirage",
      subscription: null,
      subscription_b: null,
      lobbyUsersA: [],
      lobbyUsersB: [],
      chat_messages: [],
      currentUserReady: false,
      currentUserHasAccess: true,
      currentUserRole: "player",
      connect_link: "",
      lobby: {},
      lobbyId: "",
      lobbyUrl: "connect {{server}}",
      chatMessageInterval: {},
      canSendChatMessage: true
    };
  },
  metaInfo() {
    return {
      // title: `${this.blogpost.title}`
    };
  },
  computed: {
    teamAName: function() {
      return this.lobby.team1_name;
    },
    teamBName: function() {
      return this.lobby.team2_name;
    },
    currentUser: function() {
      return this.$store.getters.user;
    }
  },
  methods: {
    reloadLobbyUsers() {
      var self = this;
      if (this.$route.params.id === undefined) {
        this.subscription.unsubscribe();
      }

      this.$http
        .get("/lobbies/" + this.$route.params.id + ".json")
        .then(response => {
          self.lobbyUsersA = response.data.lobby_users_a;
          self.lobbyUsersB = response.data.lobby_users_b;
          self.currentUserRole = response.data.current_user_level;
          self.currentUserHasAccess = response.data.current_user_has_access;
        });
    },
    initialize: function() {
      var self = this;
      this.lobbyId = this.$route.params.id;
      this.lobbyUrl = "https://QUEOTA.club/lobbies/" + this.$route.params.id;

      if (this.$store.getters.lobby.id) {
        this.$router.push({
          name: "RoomSingle",
          params: { id: this.$store.getters.lobby.id }
        });
      }

      this.$http
        .post("/lobbies/" + this.$route.params.id + "/join.json")
        .then(response => {
          this.lobby = response.data;
          this.$store.commit("updateLobby", this.lobby);
        })
        .catch(error => {
          this.$router.push({ name: "Home" });
        });

      this.subscription = this.$cable.subscriptions.create(
        {
          channel: "LobbiesChannel",
          lobby: this.$route.params.id,
          currentUserId: this.$store.getters.user.id
        },
        {
          received: function(data) {
            if (data.action == "message") {
              var audio = new Audio("/chat-message.mp3");
              audio.volume = 0.25;
              audio.play();
              self.chat_messages.push(data);
            } else if (data.action == "match-launching") {
              var audio = new Audio("/match-ready.mp3");
              audio.volume = 0.35;
              audio.play();
              self.chat_messages.push({
                user: "QUEOTA",
                message: "JOGO INICIADO: connect " + data.server + "; password " + data.server_password
              });
              self.connect_link = `steam://run/730//+connect ${data.server} +password ${data.server_password}`;
              self.is_eac = data.eac;
              self.server = data.server;
              self.lobbyUrl = `connect ${data.server}; password ${data.server_password}`;

              self.$http
                .get(`/lobbies/${self.$route.params.id}.json`)
                .then(response => {
                  self.$store.commit("updateLobby", response.data);
                });

              setTimeout(function() {
                self.$router.push({
                  name: "LobbySingle",
                  params: { id: self.$route.params.id }
                });
              }, 15000);
            } else if (data.action == "player-kicked") {
              self.chat_messages.push({
                user: "QUEOTA",
                message: `Usuário ${data.username} foi kickado da lobby`
              });
              if (data.user == self.currentUser.id) {
                if (data.message) {
                  self.$notify({
                    group: "all",
                    title: data.message,
                    type: "warn",
                    duration: -1000
                  });
                }

                self.subscription.unsubscribe();
                self.$router.push({ name: "Home" });
              } else self.reloadLobbyUsers();
            } else {
              // TODO maybe ensure the connected action?
              self.reloadLobbyUsers();
            }
          }
        }
      );
      self.reloadLobbyUsers();

      window.addEventListener(
        "beforeunload",
        function(event) {
          self.subscription.unsubscribe();
          self.$store.commit("leaveLobby");
        },
        false
      );
    },
    sendMessage() {
      if (this.message == "" || !this.canSendChatMessage) return;
      var self = this;

      this.$http
        .post("/chat_messages.json", {
          chat_message: { body: this.message, lobby_id: this.$route.params.id }
        })
        .then(response => {
          self.message = "";

          this.canSendChatMessage = false;
          this.$refs.chatProgressBar.classList.add("ticking");

          setTimeout(() => {
            this.canSendChatMessage = true;
            this.$refs.chatProgressBar.classList.remove("ticking");
          }, 3000);
        });
    },
    swapTeam(params) {
      this.$http
        .put("/lobbies/" + this.$route.params.id + "/swap.json", {
          user_id: params.userId
        })
        .then(response => {});
    },
    swapReady(id) {
      this.currentUserReady = !this.currentUserReady;
      this.$http
        .put("/lobbies/" + this.$route.params.id + "/swap_ready.json", {
          user_id: this.$store.getters.user.id
        })
        .then(response => {});
    },
    kickPlayer(params) {
      this.$http
        .put("/lobbies/" + this.$route.params.id + "/kick.json", {
          user_id: params.userId
        })
        .then(response => {});
    },
    startPug() {
      this.$http
        .put("/lobbies/" + this.$route.params.id + "/start.json", {
          map: this.map
        })
        .then(response => {
          prompt(
            "Servidor liberado! Conecte no console com o seguinte comando",
            "connect " + response.body.server + "; password " + response.body.server_password
          );
        });
    },
    matchCheck() {
      // return this.lobbyUsersA.length > 0 && this.lobbyUsersB.length > 0;
      return false;
    }
  },
  mounted() {
    this.initialize();
  },
  beforeRouteLeave(to, from, next) {
    this.subscription.unsubscribe();
    this.$store.commit("leaveLobby");
    next();
  },
  watch: {
    "$route.params.id": function(id) {
      this.initialize();
    }
  },
  components: {
    LobbyChat,
    LobbyTeam
  }
};
</script>

<style lang="sass">
  @keyframes slowMode
    0%
      width: 100%
    100%
      background: #777
      width: 0%

  .lobby-widget-container
    display: none !important

  .room-single
    .chat-container
      // border: 1px solid rgba(255, 255, 255, 0.2)
      .chat-header
        padding: 10px
        background: rgba(0, 0, 0, .2)
        display: flex
        align-items: center
        h4
          margin: 0
          font-size: 13px
          flex: 1
          strong
            display: block
            font-size: 24px
        .info
          flex: 0 100px
          font-size: 12px
      input.input
        background: rgba(0, 0, 0, .8)
        border-radius: 0
        border: 0
        color: white
        &::placeholder
          color: #ccc
      
    .form-chat
      border: 1px solid #999
      border-radius: 4px
      margin-top: 2px
      background: rgba(0, 0, 0, 0.2)
      .form-control
        border: 0
        outline: 0
        background: transparent
        font-size: 13px
        color: white
        &:hover, &:active, &:focus
          outline: 0
          border: 0
          box-shadow: none
      .progress-indicator
        position: relative
        min-height: 4px
        border-bottom-left-radius: 4px
        border-bottom-right-radius: 4px
        overflow: hidden
        .bar
          // width: 100%
          height: 4px
          background: #000
          // border-bottom-left-radius: 4px
          // border-bottom-right-radius: 4px
          &.ticking
            animation: slowMode 3s 0s linear

    .ready-button
      display: block
      font-size: 24px
      background: rgb(60,214,40)
      background: linear-gradient(13deg, rgba(60,214,40,0.5) 13%, rgba(39,83,39,0.5) 80%)
      padding: 10px
      border: 1px solid green
      line-height: 100%
      margin-top: 5px
      font-weight: bold
      border-radius: 4px
      color: white
      &:hover
        background: linear-gradient(13deg, rgba(60,214,40,0.5) 43%, rgba(39,83,39,0.5) 80%)
        text-decoration: none
        color: black
        font-weight: bold
      span
        font-size: 14px
        font-weight: normal
        display: block
        padding: 0
        margin: 0
    
    .game-ready-modal
      position: fixed
      top: 0
      left: 0
      width: 100%
      height: 100%
      background: rgba(0, 0, 0, .9)
      z-index: 100
      display: flex
      justify-content: center
      transition: all .7s

      .content
        width: 85%
        max-width: 880px
        a
          color: white
        h1
          margin-top: 80px
          font-weight: bold
          font-size: 84px
          margin-bottom: 0
          position: relative
          z-index: 103
        .box-container
          background: rgba(0, 0, 0, .8)
          padding: 50px 10px 30px
          position: relative
          top: -40px
          z-index: 102
          text-align: center
          display: flex
          justify-content: center
          
          p
            font-weight: bold
            opacity: 1
          
          .anti
            display: inline-block
            width: 250px
            img 
              max-width: 150px

          .server
            display: inline-block
            width: 400px
            padding-top: 70px
            padding-left: 60px

            font-size: 24px
            color: white
            input
              font-size: 18px
              padding: 4px 8px
              width: 60%
</style>
